import { render, staticRenderFns } from "./installmentsPaymentsHistory.vue?vue&type=template&id=7b2c40d8&"
import script from "./installmentsPaymentsHistory.vue?vue&type=script&lang=js&"
export * from "./installmentsPaymentsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports